import React from 'react'
import injectStyles from 'react-jss'
import cn from 'classnames'
import { styles } from './styles'
import Button from '@material-ui/core/Button'

const OutlinedButton = ({
  classes,
  onClick,
  label,
  icon,
  disabled,
  alwaysActive = false,
  cypress_id,
}) => {
  return (
    <Button
      variant="outlined"
      startIcon={icon}
      onClick={onClick}
      className={cn(classes.button, { [classes.alwaysActive]: alwaysActive })}
      disabled={disabled}
      cypress_id={cypress_id}
    >
      {label}
    </Button>
  )
}

export default injectStyles(styles)(OutlinedButton)
